export default __webpack_public_path__ + "static/media/trackable.9ebcda26.png";